.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  box-sizing: border-box;
  width: 100%;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

.category-subcategory-listing {
  position: relative;
  display: block;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

.category-subcategory-listing *,
.category-subcategory-listing *::before,
.category-subcategory-listing *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing {
    flex-direction: row;
  }
}

.category-subcategory-listing__filters {
  display: flex;
  flex-direction: column-reverse;
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing__filters {
    flex-direction: column;
    flex: 0 0 280px;
  }

  :host(:not([dir="rtl"])) .category-subcategory-listing__filters {
    margin-right: 20px;
    margin-left: 10px;
  }

  :host([dir="rtl"]) .category-subcategory-listing__filters {
    margin-left: 20px;
    margin-right: 10px;
  }
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing__content {
    padding: 0;
    flex: 1 1 auto;
  }
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing__content.category-subcategory-listing__content--with-subcategory {
    margin-top: 40px;
  }
}

.category-subcategory-listing__products--hidden {
  display: none;
}

@media screen and (max-width: 719px) {
  .category-subcategory-listing__products {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.category-subcategory-listing__hmc-banner {
  margin-bottom: 16px;
}

@media screen and (max-width: 719px) {
  .category-subcategory-listing__hmc-banner {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing__hmc-banner {
    margin-top: 12px;
  }

  .category-subcategory-listing__hmc-banner--top {
    margin-top: 0;
  }
}

.hidden-subcategories {
  display: none;
}

.category-subcategory-listing__overlay {
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fafafa;
  opacity: 0.4;
}

.category-subcategory-listing__overlay:not(.category-subcategory-listing__overlay--visible) {
  display: none;
}

@media screen and (max-width: 979px) {
  .category-subcategory-listing__overlay {
    position: fixed;
  }
}

@media screen and (min-width: 980px) {
  .category-subcategory-listing__overlay {
    position: absolute;
  }
}